import { Produit } from 'src/app/parametrage/core/model/produit';
import { Assurance } from 'src/app/parametrage/core/model/assurance';

export class ParticulierFaciliteItem
{
    produit:String;
    assurance:String;
    montant:number;
    objetDemande : String;
    dateRemboursementDerniereMensualite : String;
    periodicite : String;
    echeance:number;
    echeanceMensuelleEnCours:number;
    nombreEcheance:number;
    taux:number;
    frais:number;
    typeMontantVirementPermanent : String;
    montantVirementPermanent:number;
}